// Generated types for TaskRun
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { NodeAPIReadAPI, NodeAPIWriteAPI } from '../../shared/types/nodeapi';
import { TaskNodeReadAPI } from './tasknode';
import { UserReadAPI } from '../../base/types/user';
import { NodeAPIReadAPISchemaObject, NodeAPIWriteAPISchemaObject } from '../../shared/types/nodeapi';
import { TaskNodeReadAPISchema } from './tasknode';
import { UserReadAPISchema } from '../../base/types/user';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface TaskRunReadAPI extends NodeAPIReadAPI {
  task?: TaskNodeReadAPI | null;
  user?: UserReadAPI | null;
  time_stamp?: string | null;
  ellapsed_ms?: number | null;
}

export interface TaskRunWriteAPI extends NodeAPIWriteAPI {
  task?: TaskNodeReadAPI | null;
  user?: UserReadAPI | null;
  time_stamp?: string | null;
  ellapsed_ms?: number | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const TaskRunReadAPISchema: z.ZodType<TaskRunReadAPI> = NodeAPIReadAPISchemaObject.extend({
  task: z.lazy(() => TaskNodeReadAPISchema).nullable().optional(),
  user: z.lazy(() => UserReadAPISchema).nullable().optional(),
  time_stamp: z.string().nullable().optional(),
  ellapsed_ms: z.number().nullable().optional(),
}).passthrough();

export const TaskRunWriteAPISchema: z.ZodType<TaskRunWriteAPI> = NodeAPIWriteAPISchemaObject.extend({
  task: z.lazy(() => TaskNodeReadAPISchema).nullable().optional(),
  user: z.lazy(() => UserReadAPISchema).nullable().optional(),
  time_stamp: z.string().nullable().optional(),
  ellapsed_ms: z.number().nullable().optional(),
}).passthrough();
